var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaskDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.784912,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#E7F0FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3734_29721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 12.7849C18.4178 12.7849 16.871 13.2541 15.5554 14.1332C14.2398 15.0122 13.2145 16.2616 12.609 17.7234C12.0035 19.1853 11.845 20.7938 12.1537 22.3456C12.4624 23.8975 13.2243 25.3229 14.3431 26.4418C15.462 27.5606 16.8874 28.3225 18.4393 28.6312C19.9911 28.9399 21.5997 28.7814 23.0615 28.1759C24.5233 27.5704 25.7727 26.5451 26.6518 25.2295C27.5308 23.9139 28 22.3672 28 20.7849C27.9938 18.6651 27.149 16.6338 25.6501 15.1349C24.1511 13.6359 22.1198 12.7911 20 12.7849V12.7849ZM18.6667 24.3942L15.0573 20.7849L16 19.8422L18.6667 22.5089L24 17.1756L24.9427 18.1182L18.6667 24.3942Z",
    fill: "#86B4F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3734_29721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.7849)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskDone);
export default __webpack_public_path__ + "static/media/task-done.8d43890b376f07e08d50bd38134b49ef.svg";
export { ForwardRef as ReactComponent };